var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntercom = function SvgIntercom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 27.083c.69 0 1.25.56 1.25 1.25v.017a1.25 1.25 0 0 1-2.5 0v-.017c0-.69.56-1.25 1.25-1.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.333 3.75A4.583 4.583 0 0 0 3.75 8.333v23.334a4.584 4.584 0 0 0 4.583 4.583h13.334a4.584 4.584 0 0 0 4.583-4.583V8.333a4.583 4.583 0 0 0-4.583-4.583zM6.86 6.86c.39-.39.92-.61 1.473-.61h3.822q-.071.196-.072.417c0 .69.56 1.25 1.25 1.25h3.334a1.25 1.25 0 0 0 1.178-1.667h3.822a2.083 2.083 0 0 1 2.083 2.083v23.334a2.083 2.083 0 0 1-2.083 2.083H8.333a2.083 2.083 0 0 1-2.083-2.083V8.333c0-.552.22-1.082.61-1.473",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36.04 10.694a1.25 1.25 0 0 0-2.08-1.387l-3.333 5c-.28.42-.28.967 0 1.386L33.497 20l-2.87 4.307c-.28.42-.28.967 0 1.387l3.333 5a1.25 1.25 0 0 0 2.08-1.387L33.17 25l2.871-4.306c.28-.42.28-.967 0-1.387L33.17 15z"
  })));
};
export default SvgIntercom;